module.exports = __webpack_public_path__ + "static/img/9570_phase_function_Paper_Points.e9a600d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9570_phase_function_Paper_Points.png
// module id = 8x4w
// module chunks = 0